// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4264":"08715e9b","6433":"82020103"}[chunkId] + ".chunk.css";
};